/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.ExamAttemptService
 */
import * as References from './ExamAttemptService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.ExamAttemptService#start
 */
export const START_MUTATION_FIELD_NAME = 'com_hubspot_academy_assessments_rpc_ExamAttemptService_start';
export const START_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: START_MUTATION_FIELD_NAME,
  args: ['examId', 'language', 'academyLanguage', 'trackId', 'playlistId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.startRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.ExamAttemptService#resume
 */
export const RESUME_MUTATION_FIELD_NAME = 'com_hubspot_academy_assessments_rpc_ExamAttemptService_resume';
export const RESUME_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: RESUME_MUTATION_FIELD_NAME,
  args: ['attemptId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.resumeRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.ExamAttemptService#submitQuestion
 */
export const SUBMIT_QUESTION_MUTATION_FIELD_NAME = 'com_hubspot_academy_assessments_rpc_ExamAttemptService_submitQuestion';
export const SUBMIT_QUESTION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SUBMIT_QUESTION_MUTATION_FIELD_NAME,
  args: ['attemptId', 'questionSubmission'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.submitQuestionRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.ExamAttemptService#validate
 */
export const VALIDATE_MUTATION_FIELD_NAME = 'com_hubspot_academy_assessments_rpc_ExamAttemptService_validate';
export const VALIDATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: VALIDATE_MUTATION_FIELD_NAME,
  args: ['attemptId', 'trackId', 'playlistId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.validateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});